import React from 'react'
import { Box, Typography } from '@mui/material'

interface GrayBoxProps {
  title?: string;
  children: React.ReactNode;
}

const GrayBox: React.FC<GrayBoxProps> = ({ title, children }) => (
  <Box sx={{
    bgcolor: '#3333330D',
    borderRadius: '8px',
    display: 'flex',
    padding: '24px',
    alignItems: 'flex-start',
    flexDirection: 'column',
  }}
  >
    <Typography sx={{ color: 'textPrimary.main' }}>
      <strong>{title}</strong>
    </Typography>
    {children}
</Box>
)

export default GrayBox